export default "__VITE_ASSET__Cr8ZHOuU__"